import NewsService from 'services/news/NewsService';

export default {
	'services.newsService': {
		class: NewsService,
		deps: [{ $ref: 'services.APIService' }, { $ref: 'services.tagService' }],
	},
};
